import { render, staticRenderFns } from "./OrdersPartner.vue?vue&type=template&id=bcd31e78&"
import script from "./OrdersPartner.vue?vue&type=script&lang=js&"
export * from "./OrdersPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports